import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import { CardElement, injectStripe } from 'react-stripe-elements';
import LocalizedStrings from 'react-localization';
import Message from '../Message/Message';
import en from './locales/en.json';
import fr from './locales/fr.json';


const strings = SetComponentLanguage(LocalizedStrings, en, fr);

const createOptions = () => {
    return {
      style: {
        base: {
          fontSize: '16px',
          color: '#424770',
          fontFamily: 'Open Sans, sans-serif',
          letterSpacing: '0.025em',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
        invalid: {
          color: '#c23d4b',
        },
      }
    }
  };

class CheckoutForm  extends Component {
    constructor(props) {
        super(props);
        this.state = { 
			message: {
                title: '',
                content: '',
                type: '',
            },
		};
        this.submit = this.submit.bind(this);
    }

    submit = async (ev) => {
        const token = await this.props.stripe.createToken(
            {
                name: `${this.props.name} - ${this.props.email}`,
                address_country: this.props.country,
            }
        ).then(this.props.handleResult)
        console.log('token', token);
        /* let response = await fetch("/charge", {
            method: "POST",
            headers: {"Content-Type": "text/plain"},
            body: token.id
        }); */

        if (token.token) {
            this.props.returnToken(token);
        }
        if (token.error) {
            this.setMessage('Oops!', token.error.message, 'error');
        }
    }

    setMessage = (title, content, type) => {
        const message = { ...this.state.message };
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    render() {
        return (
            <div className="checkout text-center">
                <Message
                    message={this.state.message}
                />
                <CardElement
                    {...createOptions()}
                />
                <button
                    className="showtix-button showtix-background__primary-2 mt-3"
                    onClick={this.submit}
                    disabled={this.props.checkoutInProgress}
                >
                    <span>
                        Pay with card
                    </span>
                </button>
            </div>
        );   
    }
}

export default injectStripe(CheckoutForm);


// WEBPACK FOOTER //
// ./src/components/Common/CheckoutForm/CheckoutForm.js